



function JobJD() {

    return (
        <div className="canLisWrap">
            <div className="m-4 p-4 bg-white w-100 b">
                <div className="row">
                    <div className="col-md-2">
                        <h5>Digital Marketing Executive</h5><br />
                        <h6></h6>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default JobJD